import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

interface Props {
  panelSize: number
  numberOfPanels: number
  onPanelSizeChange: (size: number) => void
  onNumberOfPanelsChange: (count: number) => void
}

export const ConjointSettings: React.FC<Props> = ({
  panelSize,
  numberOfPanels,
  onPanelSizeChange,
  onNumberOfPanelsChange
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="panel-size-label">Panel Size</InputLabel>
        <Select
          labelId="panel-size-label"
          value={panelSize}
          label="Panel Size"
          onChange={(e) => onPanelSizeChange(Number(e.target.value))}
        >
          <MenuItem value={2}>2 options</MenuItem>
          <MenuItem value={3}>3 options</MenuItem>
          <MenuItem value={4}>4 options</MenuItem>
          <MenuItem value={5}>5 options</MenuItem>
          <MenuItem value={6}>6 options</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="number-of-panels-label">Number of panels</InputLabel>
        <Select
          labelId="number-of-panels-label"
          value={numberOfPanels}
          label="Number of panels"
          onChange={(e) => onNumberOfPanelsChange(Number(e.target.value))}
        >
          {Array.from({ length: 16 }, (_, i) => i + 5).map((num) => (
            <MenuItem key={num} value={num}>
              {num}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
